export default __webpack_public_path__ + "static/media/schlock-feb-2022.e4e0ecd3.jpg";